export const ALLOWED_OAUTH_PROVIDERS = [
  "AppalachianUnderwriters",
  "FirstConnect",
  "JohnsonAndJohnson",
  "TheColonialGroup",
  "SUG",
  "SouthAndWestern",
  "BSG",
];

export const GENERAL_EMAIL_ADDRESS = "team@covertree.com";
export const HELP_EMAIL_ADDRESS = "help@covertree.com";
export const AGENT_HELP_ADDRESS = "agentservice@covertree.com";
export const CLAIMS_EMAIL_ADDRESS = "claims@covertree.com";
export const SALES_EMAIL_ADDRESS = "sales@covertree.com";

export const MONTHLY_SCHEDULE_FEE = 20;
export const SEMIANNUAL_SCHEDULE_FEE = 6;
export const SEMIANNUAL_REVISION_SCHEDULE_FEE = 8;

export const AWS_DATE_LENGTH = 10;

export const POLICY_CLOSE_EXPIRATION_ENDORSEMENT_MSG =
  "Policy is close to expiration - new endorsements are unavailable.";

export const DISABLED_TOOLTIP_TEXT =
  "Not available due to policy status or insufficient permissions";

export const ONLY_ONE_ESIGN_REMINDER_MSG = "can only send one reminder";
export const NOT_ELIGIBLE_FOR_ESIGN_MSG = "not eligible for e-sign reminder";
export const NOT_ALLOWED_FOR_ESIGN_MSG = "not allowed to send e-sign reminder";

export const NEW_POLICY_SUBMIT_BUTTON_ID = "new-policy-submit-button";

export * from "./files";
export * from "./states";
export * from "./socotraDocuments";
